import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MapInfoWindow, MapMarker} from '@angular/google-maps';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'common-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss']
})
export class CommonMapComponent implements OnInit {

    @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;

    title = 'Solar Central';

    latitude = -25.7856262;

    longitude = 28.2829441;

    zoom = 15;

    center: google.maps.LatLngLiteral;

    marker: any = {
        position: {
            lat: this.latitude,
            lng: this.latitude,
        },
        label: {
            color: 'red',
            text: 'SC',
        },
        title: 'Solar Central'
    };

    constructor(@Inject(DOCUMENT) public document: Document) {
    }

    ngOnInit(): void {
        this.center = {
            lat: this.latitude,
            lng: this.longitude,
        };
    }

    openInfo(marker: MapMarker) {
        this.infoWindow.open(marker);
    }
}
